<template>
  <!-- confirmModal -->
  <div
    class="modal fade"
    id="my-gacha-prize-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="mySmallModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="gacha-text-color">我的獎品</h5>
          <div
            class="ml-auto pointer"
            data-dismiss="modal"
            aria-label="Close"
            @click="closeModal()"
          >
            <i class="fa-solid fa-xmark fa-xl text-darkdark"></i>
          </div>
        </div>
        <div class="modal-body">
          <!-- 獎品列表 -->
          <div v-if="contentList.length > 0" class="prize-grid">
            <div
              v-for="prize in contentList"
              :key="prize.record_id"
              class="prize-item"
              :class="{
                'prize-claimed': prize.is_claimed,
                'prize-unclaimed': !prize.is_claimed,
              }"
            >
              <!-- 獎品狀態徽章 -->
              <div class="prize-status-badge">
                <span v-if="prize.is_claimed" class="badge badge-claimed">
                  <i class="fa-solid fa-check text-white"></i> 已領取
                </span>
                <span v-else class="badge badge-unclaimed">
                  <i class="fa-solid fa-clock text-white"></i> 待領取
                </span>
              </div>

              <!-- 獎品類型徽章 -->
              <div class="prize-type-badge">
                <span
                  v-if="prize.type === 'physical'"
                  class="type-badge physical"
                >
                  <i class="fa-solid fa-box text-white"></i> 實體
                </span>
                <span v-else class="type-badge virtual">
                  <i class="fa-solid fa-coins text-white"></i> 虛擬
                </span>
              </div>

              <div class="prize-image">
                <img :src="prize.image_url" :alt="prize.name" />
                <!-- 已領取獎品的遮罩效果 -->
                <!-- <div v-if="prize.is_claimed" class="">
                  <i class="fa-solid fa-check-circle claimed-icon"></i>
                </div> -->
              </div>
              <div class="prize-details">
                <div class="prize-name" id="gacha-text-color">
                  {{ prize.name }}
                </div>
                <div class="prize-date">
                  獲得時間: {{ formatDate(prize.obtained_at) }}
                </div>
                <!-- 運送狀態 (僅實體獎品顯示) -->
                <div v-if="prize.type === 'physical'" class="shipping-status">
                  <span class="shipping-label">運送狀態:</span>
                  <span
                    class="shipping-value"
                    :class="getShippingStatusClass(prize.shipping_status)"
                  >
                    {{ getShippingStatusText(prize.shipping_status) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- 無獎品提示 -->
          <div v-else class="no-prizes">
            <p>您還沒有獲得任何獎品，趕快去抽獎吧！</p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            @click="closeModal()"
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
          >
            {{ $t("ok") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  contentList: { type: Array, default: () => [] },
});

// 格式化日期函數
const formatDate = (date) => {
  if (!date) return "";

  try {
    // 將ISO格式日期字符串轉換為日期對象
    const dateObj = new Date(date);

    // 如果日期無效，返回原始字符串
    if (isNaN(dateObj.getTime())) return date;

    // 只格式化為年月日，不顯示時間
    return dateObj.toLocaleDateString("zh-TW", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  } catch (error) {
    console.error("日期格式化錯誤:", error);
    return date; // 出錯時返回原始字符串
  }
};

// 獲取運送狀態的樣式類別
const getShippingStatusClass = (status) => {
  switch (status) {
    case "pending":
      return "status-pending";
    case "shipped":
      return "status-shipped";
    case "delivered":
      return "status-delivered";
    default:
      return "status-unknown";
  }
};

// 獲取運送狀態的文字
const getShippingStatusText = (status) => {
  switch (status) {
    case "pending":
      return "準備中";
    case "shipped":
      return "已寄出";
    case "delivered":
      return "已送達";
    default:
      return "未知";
  }
};

const closeModal = () => {
  $("#my-gacha-prize-modal").modal("hide");
};
</script>

<style lang="scss">
.confirm-title {
  min-height: 52px;
  height: 52px;
}
.title-height {
  min-height: 52px;
  height: 52px;
}

/* 獎品列表樣式 */
.prize-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  padding: 10px;
}

.prize-item {
  border: 1px solid #f0e0d0;
  border-radius: 10px;
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  // 已領取獎品的樣式
  &.prize-claimed {
    background-color: #f8f9fa;
    border-color: #28a745;

    .prize-image {
      position: relative;
    }
  }

  // 未領取獎品的樣式
  &.prize-unclaimed {
    background-color: #fff;
    border-color: #ffc107;
    box-shadow: 0 2px 8px rgba(255, 193, 7, 0.2);

    &:hover {
      box-shadow: 0 4px 12px rgba(255, 193, 7, 0.3);
    }
  }
}

/* 獎品狀態徽章 */
.prize-status-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;

  .badge {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    i {
      font-size: 10px;
    }
  }

  .badge-claimed {
    background-color: #28a745;
    color: white;
    border: 1px solid #1e7e34;
  }

  .badge-unclaimed {
    background-color: #ffc107;
    color: #212529;
    border: 1px solid #e0a800;
  }
}

/* 獎品類型徽章 */
.prize-type-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;

  .type-badge {
    font-size: 11px;
    font-weight: 500;
    padding: 3px 6px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    gap: 3px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

    i {
      font-size: 9px;
    }

    &.physical {
      background-color: #6f42c1;
      color: white;
      border: 1px solid #5a32a3;
    }

    &.virtual {
      background-color: #17a2b8;
      color: white;
      border: 1px solid #138496;
    }
  }
}

.prize-image {
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 15px;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transition: opacity 0.3s;
  }

  /* 已領取獎品的遮罩效果 */
  .claimed-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(40, 167, 69, 0.1);
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(1px);

    .claimed-icon {
      font-size: 32px;
      color: #28a745;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      padding: 8px;
      box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
    }
  }
}

.prize-details {
  text-align: center;
}

.prize-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #58320f;
}

.prize-date {
  font-size: 14px;
  color: #888;
  margin-bottom: 8px;
}

/* 運送狀態樣式 */
.shipping-status {
  font-size: 13px;
  margin-top: 8px;
  padding: 6px 10px;
  background-color: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;

  .shipping-label {
    font-weight: 500;
    color: #6c757d;
    margin-right: 5px;
  }

  .shipping-value {
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;

    &.status-pending {
      background-color: #fff3cd;
      color: #856404;
      border: 1px solid #ffeaa7;
    }

    &.status-shipped {
      background-color: #d1ecf1;
      color: #0c5460;
      border: 1px solid #b8daff;
    }

    &.status-delivered {
      background-color: #d4edda;
      color: #155724;
      border: 1px solid #c3e6cb;
    }

    &.status-unknown {
      background-color: #f8d7da;
      color: #721c24;
      border: 1px solid #f5c6cb;
    }
  }
}

.no-prizes {
  padding: 30px;
  text-align: center;
  color: #888;
}

/* 自定義modal樣式 */
#my-gacha-prize-modal {
  .modal-content {
    border-radius: 15px;
    background-color: #fff8f0;
  }

  .modal-header {
    border-bottom: 1px solid #f0e0d0;
    background-color: #fff2e6;
    border-radius: 15px 15px 0 0;
    padding: 15px 20px;
  }

  .modal-title {
    font-weight: 700;
    font-size: 20px;
  }

  .modal-body {
    padding: 20px;
    max-height: 60vh;
    overflow-y: auto;
  }

  .modal-footer {
    border-top: 1px solid #f0e0d0;
    background-color: #fff2e6;
    border-radius: 0 0 15px 15px;
  }

  .btn-primary {
    background-color: #7a4210;
    border-color: #7a4210;

    &:hover {
      background-color: #915109;
      border-color: #915109;
    }
  }
}

@media (max-width: 768px) {
  .prize-grid {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 15px;
  }

  .prize-image {
    height: 120px;
  }

  .prize-name {
    font-size: 14px;
  }

  /* 調整徽章在小螢幕的顯示 */
  .prize-status-badge .badge {
    font-size: 10px;
    padding: 3px 6px;
  }

  .prize-type-badge .type-badge {
    font-size: 10px;
    padding: 2px 4px;
  }

  .shipping-status {
    font-size: 12px;
    padding: 4px 8px;

    .shipping-value {
      font-size: 11px;
    }
  }
}
</style>
